import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationService, PathsService, UserManagementService } from '@draeger-academy/common';
import { AuthenticationService } from '@draeger-academy/common/lib/services/authentication/authentication.service';
import { CartService } from '@draeger-academy/common/lib/services/cart/cart.service';
import { OrderService } from '@draeger-academy/common/lib/services/order/order.service';
import { FormsUtils } from '@draeger-academy/presentation/lib/modules/form-builder';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router/lib/localize-router.service';
import { Order } from 'models/order';
import { Participant } from 'models/participant';
import { User } from 'models/user';
import { Observable, Subject, BehaviorSubject, Subscription } from 'rxjs';
import { first, take } from 'rxjs/operators';
import { GenericModalService } from '../../../generic-modal';

@Component({
    selector: 'da-checklist-employees',
    templateUrl: './checklist-employees.component.html',
    styleUrls: ['./checklist-employees.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChecklistEmployeesComponent implements OnInit {
    @Input() employees: any;
    public currentNumberOfChecked: number = 0;
    public addedEmployees: Array<any> = [];
    public checkedEmployees: Array<any> = [];
    public checkedEmployeesId: Array<any> = [];
    @Output()
    addedParticipants: EventEmitter<boolean> = new EventEmitter<boolean>();

    private _$loaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public get loaded$(): Observable<{}> {
        return this._$loaded.asObservable();
    }

    constructor(private orderService: OrderService) {}

    ngOnInit() {
        this.orderService.order$.pipe(take(1)).subscribe((order) => {
            if (order.participants) {
                this.currentNumberOfChecked = order.participants.length;
                order.participants.forEach((item) => {
                    this.checkedEmployeesId.push(item.person.id);
                });
            }
            this.addedEmployees = [];
            this.addedEmployees = order.participants;
        });
    }

    public cancle() {
        this.addedParticipants.emit(false);
    }

    public addParticipants() {
        this.orderService.order$.pipe(take(1)).subscribe((order) => {
            order.participants = this.addedEmployees;
            this.orderService.updateOrder(order);
        });
        this.addedParticipants.emit(true);
    }

    public check(event, i) {
        if (event.target.checked) {
            this.currentNumberOfChecked = this.currentNumberOfChecked + 1;
            let newElement = {
                person: null,
                sameAs: false
            };

            let newPerson = {
                id: this.employees[i].id,
                billingContactId: this.employees[i].billingContactId,
                address:
                    this.employees[i].company && this.employees[i].company.street
                        ? this.employees[i].company.street
                        : this.employees[i].address,
                city: this.employees[i].company && this.employees[i].company.city ? this.employees[i].company.city : this.employees[i].city,
                company:
                    this.employees[i].company && this.employees[i].company.name
                        ? this.employees[i].company.name
                        : this.employees[i].company,
                country:
                    this.employees[i].company.country && this.employees[i].company.country.code
                        ? this.employees[i].company.country.code
                        : this.employees[i].country,
                department:
                    this.employees[i].company && this.employees[i].company.department
                        ? this.employees[i].company.department
                        : this.employees[i].department,
                email: this.employees[i].email,
                firstName: this.employees[i].firstName,
                lastName: this.employees[i].lastName,
                phone: this.employees[i].phone,
                salutation:
                    typeof this.employees[i].salutation === 'string' ? this.employees[i].salutation : this.employees[i].salutation.name,
                subscribe: this.employees[i].subscribe,
                title: this.employees[i].title,
                zipCode:
                    this.employees[i].company && this.employees[i].company.zipCode
                        ? this.employees[i].company.zipCode
                        : this.employees[i].zipCode
            };

            newElement.person = newPerson;
            newElement.sameAs = false;
            this.addedEmployees.push(newElement);
        } else {
            this.currentNumberOfChecked = this.currentNumberOfChecked - 1;

            let newElement = {
                person: null,
                sameAs: false
            };

            let newPerson = {
                id: this.employees[i].id,
                billingContactId: this.employees[i].billingContactId,
                address:
                    this.employees[i].company && this.employees[i].company.street
                        ? this.employees[i].company.street
                        : this.employees[i].address,
                city: this.employees[i].company && this.employees[i].company.city ? this.employees[i].company.city : this.employees[i].city,
                company:
                    this.employees[i].company && this.employees[i].company.name
                        ? this.employees[i].company.name
                        : this.employees[i].company,
                country:
                    this.employees[i].company.country && this.employees[i].company.country.code
                        ? this.employees[i].company.country.code
                        : this.employees[i].country,
                department:
                    this.employees[i].company && this.employees[i].company.department
                        ? this.employees[i].company.department
                        : this.employees[i].department,
                email: this.employees[i].email,
                firstName: this.employees[i].firstName,
                lastName: this.employees[i].lastName,
                phone: this.employees[i].phone,
                salutation:
                    typeof this.employees[i].salutation === 'string' ? this.employees[i].salutation : this.employees[i].salutation.name,
                subscribe: this.employees[i].subscribe,
                title: this.employees[i].title,
                zipCode:
                    this.employees[i].company && this.employees[i].company.zipCode
                        ? this.employees[i].company.zipCode
                        : this.employees[i].zipCode
            };
            newElement.person = newPerson;
            newElement.sameAs = false;

            this.addedEmployees.forEach((item, index) => {
                if (item.person.id === this.employees[i].id) {
                    this.addedEmployees.splice(index, 1);
                }
            });
        }
    }
}
